module.exports = __webpack_public_path__ + "img/gengduo.5ae15466.png";